// @flow

export class BackendError extends Error {
  status: number;
  errors: any;
  response: any;

  constructor(status: number, errors: any, response: any, ...args: any[]) {
    super(...args);

    this.status = status;
    this.errors = errors;
    this.response = response;

    if (typeof Error.captureStackTrace === 'function') {
      Error.captureStackTrace(this, BackendError);
    } else {
      this.stack = new Error().stack;
    }
  }
}

export default BackendError;



// WEBPACK FOOTER //
// ./src/common/network/BackendError.js